import {GetAllApiEnumsApiResponse} from '@dms/api/shared';

import {UNSUPPORTED_VAN_BODY_STYLE_KEYS} from '../constants/unsupportedVanBodyStyleKeys';
import {ApiEnumItem} from '../types/ApiEnum';
import {getDefaultLabel} from './getDefaultLabel';
import {getEnumByProperty, PropertyName} from './getEnumByProperty';

const toEnumItems = (
  propertyName: PropertyName,
  enums?: GetAllApiEnumsApiResponse
): ApiEnumItem[] =>
  getEnumByProperty(propertyName, enums).map((item) => ({
    key: item.const_key,
    value: item.const_key,
    label: getDefaultLabel(item),
  }));

/**
 * Body styles offered by the Sourcing `bodyType` filter.
 *
 * The vehicle catalogue splits them into `car_style` (`CARSTYLE_*`) and `van_style` (`VANSTYLE_*`);
 * sourcing filters on a single list, so both are merged, cars first. Van keys Alpha rejects in the
 * filter are dropped – offering them would fail the whole request.
 */
export const getBodyStyleEnum = (
  enums: GetAllApiEnumsApiResponse | undefined,
  isVanFiltersEnabled: boolean
): ApiEnumItem[] => {
  const carStyles = toEnumItems('car_style', enums);

  if (!isVanFiltersEnabled) {
    return carStyles;
  }

  return [
    ...carStyles,
    ...toEnumItems('van_style', enums).filter(
      (item) => !UNSUPPORTED_VAN_BODY_STYLE_KEYS.includes(item.key)
    ),
  ];
};
